import { WalletModalProvider } from './components/WalletModalContext';
import ConnectWalletModal from './components/ConnectWalletModal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TheComeback from './components/TheComeback';
import StepsSection from './components/StepsSection';
import TheSteps from './components/TheSteps';
import FaqSection from './components/FaqSection';
import CommunitySection from './components/CommunitySection';
import WalletActions from './components/WalletActions';
import Footer from './components/Footer';
import './styles/global.css';
import './styles/ScrollSections.css';

export default function App() {
  return (
    <WalletModalProvider>
      <Navbar />
      <main className="scroll-sections">
        <Hero zIndex={1} />
        <WalletActions />
        <TheComeback zIndex={2} />
        <StepsSection zIndex={3} />
        <TheSteps zIndex={4} />
        <FaqSection zIndex={5} />
        <CommunitySection zIndex={6} />
        <Footer zIndex={7} />
      </main>
      <ConnectWalletModal />
    </WalletModalProvider>
  );
}